export default "__VITE_ASSET__CDytYUz4__"